import { useContext, useMemo } from 'react';
import { useUnit } from 'effector-react';
import classNames from 'classnames';
import { Spinner } from '@nx-frontend/shared/ui/spinner';
import { GenerativeAiAddonCardProps } from '@nx-frontend/shared/types/paywall-types';
import { AddonContext } from './addon-context';
import { $paywallStore } from './store';

export const GenerativeAiAddonCard = (props: GenerativeAiAddonCardProps) => {
  const [paywallStore] = useUnit([$paywallStore]);
  const { members, price, description, total } = props;

  const { action } = useContext(AddonContext);

  const discount = useMemo(() => {
    if (action && action.discount) {
      return action.discount;
    }
    return 0;
  }, [action]);

  const styles = {
    textPriceColor: discount ? 'text-rose-500' : 'text-neutral-500',
    textDiscountOriginalPriceColor: 'text-neutral-500',
    textUsdSize: discount ? 'text-2xl' : 'text-sm',
    textPriceWeight: discount ? 'font-semibold' : 'font-normal',
  };

  return (
    <div className="py-4 pl-3 pr-4 border rounded-lg relative">
      <div className="text-lg font-semibold mb-1">Generative AI</div>
      <div className="flex items-center justify-between w-full">
        <div className="text-sm text-neutral-500">
          <span className={classNames(styles.textPriceColor, styles.textUsdSize, styles.textPriceWeight)}>
            ${!discount ? price : (price * (1 - discount / 100)).toFixed(1)}
          </span>
          {discount ? (
            <span
              className={classNames(
                'text-base font-normal inline-block mx-1 line-through',
                styles.textDiscountOriginalPriceColor
              )}
            >
              ${price}
            </span>
          ) : null}
          <span>/month x {members} members</span>
        </div>
        <div className="text-base">
          {paywallStore.fetchingOrderSummary ? <Spinner width={14} height={14} /> : '$' + total}
        </div>
      </div>
      <div className="flex items-end">
        <div className="flex-1">
          <span className="text-xs p-1 inline-block px-2 rounded bg-gray-100">{description}</span>
        </div>
      </div>
    </div>
  );
};
